import { openTimeSearchConfig } from '../../../../settings/settings';
import { ADD_REQUEST } from '../../../../data/constants';
import { between } from '../../helpers';

export function buildAddRequestData(activity, bidSession) {

  const openTimeSearchLabels = (sessionStorage.getItem('lng') === 'fr'
    ? require('../../../../labels/labels.french.json')
    : require('../../../../labels/labels.json')).openTimeSearchLabels;

  const { type: activityType, startDate: activityStartDate, endDate: activityEndDate, name: activityName } = activity;


  const { activePreferenceOptionsIds } = bidSession;

  const isReserve = activityType === openTimeSearchConfig.activityTypes.RSV;
  const isPairing = activityType === openTimeSearchConfig.activityTypes.TRP;
  const isPairingOrReserve = isReserve || isPairing;

  const label = openTimeSearchLabels.details.ADD_REQUEST;
  let requestPreferencePayload = {};
  let isPreferenceOptionActive = false;

  if (isPairing) {
    // Try ID 784 first (SPECIFIC_PAIRING_STARTING_ON_DATES - 3 parameters)
    requestPreferencePayload = { ...ADD_REQUEST.PAIRING_NUMBER_ON_DATE };
    isPreferenceOptionActive = activePreferenceOptionsIds.includes(requestPreferencePayload.preferenceOptionId);
    
    // if 784 not available and ID 132 is available (PAIRING_START_ON_DATE - 2 parameters) 
    if (!isPreferenceOptionActive) {
      requestPreferencePayload = { ...ADD_REQUEST.PAIRING_START_ON_DATE };
      isPreferenceOptionActive = activePreferenceOptionsIds.includes(requestPreferencePayload.preferenceOptionId);
    }
    
    if (isPreferenceOptionActive) {
      requestPreferencePayload.parameterValues[0].value = activityName;
      requestPreferencePayload.parameterValues[1].value = new Date(activityStartDate).toISOString().substring(0, 10);
      // Set start date only if third parameter exists (ID 784 has 3 parameters, ID 132 has 2)
      if (requestPreferencePayload.parameterValues[2]) {
        requestPreferencePayload.parameterValues[2].value = new Date(activityStartDate).toISOString().substring(0, 10);
      }
    }
  } else if (isReserve) {
    requestPreferencePayload = { ...ADD_REQUEST.RESERVE_NUMBER };
    isPreferenceOptionActive = activePreferenceOptionsIds.includes(requestPreferencePayload.preferenceOptionId);
    if (isPreferenceOptionActive) {
      requestPreferencePayload.parameterValues[0].value = activityName;
    }
  }

  return { label, requestPreferencePayload, isPreferenceOptionActive, isPairingOrReserve };
}

export function isActivityStartsInBidSessionPeriod(activity, bidSession) {
  const bidSessionStartDateUTC = new Date(bidSession.startDateUTCStr).getTime();
  const bidSessionEndDateUTC = new Date(bidSession.endDateUTCStr).getTime();
  const activityStartsInSessionPeriod = between(
    activity.startDate, bidSessionStartDateUTC, bidSessionEndDateUTC, true
  );
  return activityStartsInSessionPeriod;
}

export function isActivityEndsInBidSessionPeriod(activity, bidSession) {
  const bidSessionStartDateUTC = new Date(bidSession.startDateUTCStr).getTime();
  const bidSessionEndDateUTC = new Date(bidSession.endDateUTCStr).getTime();
  const activityEndsInSessionPeriod = between(
    activity.endDate, bidSessionStartDateUTC, bidSessionEndDateUTC, true
  );
  return activityEndsInSessionPeriod;
}
